<template>
  <div class="dropWrap">
    <ul>
      <li>
        <router-link to="/settings" class="settings"><i></i>系统设置</router-link>
      </li>
      <li>
        <a href="/javascript:;" class="version" @click.prevent="version"><i></i>版本信息</a>
      </li>
    </ul>
  </div>
</template>

<script>

  export default {
    name: 'SettingsDropdown',
    components:{},
    data(){
      return {

      }
    },
    methods:{
      version(){
        this.$emit('visible',true)
      }
    }
  }
</script>

<style scoped lang="less">
  .dropWrap{
    background: #fff;
    width: 150px;
    border-radius: 8px;
    position: absolute;
    top: 68px;
    left: -54px;
    border: 1px solid #e5e5e5;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
    z-index: 99;
  &:before{
     content: "";
     width: 100%;
     height: 8px;
     background: url(../../assets/images/img_sj.png) no-repeat;
     background-size: 15px 8px;
     background-position: 80px 0;
     position: absolute;
     top: -8px;
     left: 0;
   }
    ul{
      li{
        + li{
          border-top: 1px dashed #ededed;
        }
        a{
          display: block;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 14px;
          color: #428bca;
          i{
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin-top: -3px;
            margin-right: 6px;
          }
          &.settings{
            i{
              background: url("../../assets/images/img_setting.png") no-repeat;
              background-size: 17px 18px;
              background-position: center center;
            }
          }
          &.version{
            i{
              background: url("../../assets/images/img_version.png") no-repeat;
              background-size: 19px 18px;
              background-position: center center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/SettingsDropdown.vue